import BalanceRulesRenderer from './BalanceRulesRenderer'

class CapRulesCell extends BalanceRulesRenderer {
    _getRuleValue(ptoData) {
        return ptoData.balanceCap !== null ? this.formatter(ptoData.balanceCap) : "&ndash;";
    };

    _customClassName(ptoData) {
        return "capRule";
    };
}

export default CapRulesCell



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/CapRulesCell.js